/* eslint-disable no-unused-vars */
import store from './index'
import { getSessionStore } from '../utils/storage'
import {
    PROJECT_EDIT,
    ACCESS_TOKEN,
    USER,
    MENUS,
    MENU_BUTTONS,
    TABS_ROUTES
} from './mutation-types'

export default function initStore() {

    store.commit('app/setProjectIsEdit', getSessionStore(PROJECT_EDIT))
    
    store.commit('user/SET_TOKEN', getSessionStore(ACCESS_TOKEN))
    store.commit('user/SET_USER', getSessionStore(USER))

    store.commit('tabsView/initTabs', getSessionStore(TABS_ROUTES))

    store.commit('permission/SET_MENUS', getSessionStore(MENUS))
    store.commit('permission/SET_MENU_BUTTONS', getSessionStore(MENU_BUTTONS))

    // store.commit('SET_SIDEBAR_TYPE', getStore(SIDEBAR_TYPE, true));
    //
    // store.commit('TOGGLE_MULTI_TAB', getStore(DEFAULT_MULTI_TAB, config.multiTab));

    // last step
}
